<div class="card">
    <h5>{{reportName}}</h5>
    <div class="p-grid">
        <div class="p-col-12">
            <app-saved-search-table-view
                [savedSearchId]="savedSearchId"
                [inPageMenu]="true">
            </app-saved-search-table-view>
        </div>
    </div>
</div>
